exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sliding-panel-wrapper{z-index:99999}.sliding-panel-wrapper .sliding-panel{z-index:9999;position:fixed;right:0;top:0;width:300px;height:100%;background:-webkit-linear-gradient(115deg,#0e233c,#3872a2);background:-moz-linear-gradient(115deg,#0e233c,#3872a2);background:-o-linear-gradient(115deg,#0e233c,#3872a2);background:linear-gradient(335deg,#0e233c,#3872a2);box-shadow:-2px 0 4px rgba(0,0,0,.3);overflow-y:auto}.sliding-panel-wrapper .shade{background:rgba(0,0,0,.6);position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9998}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/SlidingPanel/SlidingPanel.scss
// module id = 873
// module chunks = 0